import { render, staticRenderFns } from "./EditSymptomsDialog.vue?vue&type=template&id=05e6c784&scoped=true"
import script from "./EditSymptomsDialog.vue?vue&type=script&lang=js"
export * from "./EditSymptomsDialog.vue?vue&type=script&lang=js"
import style0 from "./EditSymptomsDialog.vue?vue&type=style&index=0&id=05e6c784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e6c784",
  null
  
)

export default component.exports